export const SPECIAL_TOKEN_ID = "toKn314217";
export const BGR_TOKEN_ID = "toKn313762";

export const SPECIAL_ITEMIZER_CODES = ["LBM", "SBR", "AMH", "LPH", "IAC", "TBCANA"];
export const BGR_ITEMIZER_CODES = ["PBGR", "DBGR", "TBBGR"];

const ITEMIZER_CODES_BY_TOKEN = {
  [SPECIAL_TOKEN_ID]: SPECIAL_ITEMIZER_CODES,
  [BGR_TOKEN_ID]: BGR_ITEMIZER_CODES,
};

export const isSpecialItemizerLogin = ({ token }) =>
  Object.prototype.hasOwnProperty.call(
    ITEMIZER_CODES_BY_TOKEN,
    String(token || "")
  );

export const getItemizerCodesForToken = ({ token }) =>
  ITEMIZER_CODES_BY_TOKEN[String(token || "")] || [];

export const hasTokenItemizerTabs = ({ token }) =>
  getItemizerCodesForToken({ token }).length > 0;

export const getItemizerRoute = (code, index) =>
  index === 0
    ? "/details/itemizers"
    : `/details/itemizers-${String(code).toLowerCase()}`;

export const getIndexedFieldName = (baseName, index) =>
  index === 0 ? baseName : `${baseName}${index}`;
